<app-header></app-header>
<ion-content class="gray-content-bg">
  <div class="scrolling-container" cdkVirtualScrollingElement>
    <div
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      class="image-background"
    >
      <ion-grid class="image-title-grid">
        <ion-row class="image-title-row">
          <ion-col>
            <ion-text class="image-title">
              {{ 'i18n.pageTitles.sellerShowcaseProducts' | translate |
              uppercase }}
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div class="layout {{ platformService?.platformType }}">
      <div class="description-text-box {{ platformService?.platformType }}">
        <div class="description">
          <h4
            [class.mobile]="
              platformService?.platformType === platformService?.platformEnum?.mobile
            "
          >
            {{ 'i18n.sellerShowcasePage.header' | translate }}
          </h4>
          <div
            data-cy="seller-showcase-description"
            [style.display]="isDescriptionExpanded ? 'block' : 'none'"
          >
            <p>{{ 'i18n.sellerShowcasePage.description' | translate }}</p>
          </div>
        </div>
        <div class="view-more" (click)="expandDescription()">
          <div>
            {{ isDescriptionExpanded ? ('i18n.common.viewLess' | translate) :
            ('i18n.common.viewMore' | translate) }}
          </div>
          <ion-icon
            *ngIf="!isDescriptionExpanded"
            name="chevron-down-outline"
            class="chevron"
          ></ion-icon>
          <ion-icon
            *ngIf="isDescriptionExpanded"
            name="chevron-up-outline"
            class="chevron"
          ></ion-icon>
        </div>
      </div>
    </div>

    <div class="promotions-container {{ platformService?.platformType }}">
      <ng-container
        *ngIf="!!viewModel && !viewModel?.loadingPromotionalProducts; else loadingSpinner"
      >
        <ng-container *ngIf="!viewModel?.noPromotionsFound; else noPromotions">
          <app-seller-showcase-divisional-promotions
            [divisionalPromotions]="viewModel?.divisionalPromotions"
            [sectionHeaders]="promotionsSectionHeaders"
            [isOnline]="(panAppState.online$ | async)"
            [filtersApplied]="filtersApplied"
            [pricingDisabled]="viewModel?.selectedCustomer?.ogPrintPriceInd === 'N'"
            [allProductsAvailable]="viewModel?.allProductsAvailable"
            (ellipsisClickEmitter)="handleEllipsisClick($event)"
            (promotionalProductClickEmitter)="handleProductClick($event)"
            (searchWithinEmitter)="handleSearchWithin($event)"
            (updateExpansionEventEmitter)="handleUpdateExpansionEvent($event)"
            (updateSortEventEmitter)="handleUpdateSortEvent($event)"
            (filterClickEmitter)="handleOpenFilterModal()"
            (clearAllClickEmitter)="handleClearAllFilters()"
            (changeQuantityEmitter)="handleQuantityChange($event)"
          >
          </app-seller-showcase-divisional-promotions>
        </ng-container>
      </ng-container>
    </div>

    <ng-template #loadingSpinner>
      <div class="spinner-container">
        <ion-spinner
          name="circles"
          data-cy="loading-spinner-icon"
        ></ion-spinner>
      </div>
    </ng-template>

    <ng-template #noPromotions>
      <div class="no-promotions-container">
        <ion-img
          data-cy="'seller-showcase-no-promotions-image'"
          src="assets/images/box-dimension-black.svg"
        ></ion-img>
        <h6
          data-cy="seller-showcase-no-promotions-heading"
          class="heading text {{ platformService?.platformType }}"
        >
          {{ 'i18n.sellerShowcasePage.noPromotionsHeading' | translate }}
        </h6>
        <p
          data-cy="seller-showcase-no-promotions-description"
          class="description text"
        >
          {{ 'i18n.sellerShowcasePage.noPromotionsDescription' | translate }}
        </p>
      </div>
    </ng-template>

    <app-footer [ngClass]="platformService?.platformType"></app-footer>
  </div>
</ion-content>
